import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ButtonProps, IconButton } from "@mui/material";
import {
  gridFilteredDescendantCountLookupSelector,
  GridRenderCellParams,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";

const ExpandOrCollapseCell = (props: GridRenderCellParams) => {
  const { id, field, rowNode } = props;
  const apiRef = useGridApiContext();
  const filteredDescendantCountLookup = useGridSelector(
    apiRef,
    gridFilteredDescendantCountLookupSelector
  );

  const filteredDescendantCount =
    filteredDescendantCountLookup[rowNode.id] ?? 0;
  const isParentRow = filteredDescendantCount > 0 && rowNode.type === "group";

  const handleClick: ButtonProps["onClick"] = (event) => {
    if (rowNode.type !== "group") return;

    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    apiRef.current.setCellFocus(id, field);
    event.stopPropagation();
  };

  return (
    <>
      {isParentRow && (
        <IconButton
          onClick={handleClick}
          size="small"
          data-testid={`${id}-grouping-cell-${
            rowNode.childrenExpanded ? "collapse" : "expand"
          }`}
        >
          {rowNode.childrenExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
        </IconButton>
      )}
    </>
  );
};
export default ExpandOrCollapseCell;
